import { motion } from "framer-motion";

const cell = "border border-white/10 bg-zinc-900/40 p-4 rounded-sm hover:border-emerald-500/40 transition-colors";
const label = "font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-2";
const value = "font-mono-display text-white text-lg leading-tight";

const StatCard = ({ label: l, value: v, span = "", color = "white", testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    className={`${cell} ${span}`}
    data-testid={testId}
  >
    <div className={label}>{l}</div>
    <div className={`${value} ${color === "green" ? "text-emerald-500" : color === "fuchsia" ? "text-fuchsia-400" : "text-white"} break-words`}>
      {v || "—"}
    </div>
  </motion.div>
);

export const BentoStats = ({ analysis }) => {
  if (!analysis) return null;

  const instruments = Array.isArray(analysis.instruments)
    ? analysis.instruments.join(", ")
    : analysis.instruments;

  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3" data-testid="bento-stats">
      <StatCard testId="stat-bpm" label="tempo" value={analysis.bpm} color="green" span="md:col-span-1" />
      <StatCard testId="stat-key" label="key" value={analysis.key} color="green" span="md:col-span-1" />
      <StatCard testId="stat-genre" label="genre" value={analysis.genre} span="md:col-span-2" />
      <StatCard testId="stat-subgenre" label="subgenre" value={analysis.subgenre} span="md:col-span-2" />
      <StatCard testId="stat-mood" label="mood" value={analysis.mood} color="fuchsia" span="md:col-span-3" />
      <StatCard testId="stat-energy" label="energy" value={analysis.energy} color="fuchsia" span="md:col-span-3" />
      <StatCard testId="stat-vocals" label="vocals" value={analysis.vocals} span="md:col-span-3" />
      <StatCard testId="stat-instruments" label="instruments" value={instruments} span="md:col-span-3" />
      <StatCard testId="stat-structure" label="structure" value={analysis.structure} span="md:col-span-2" />
      <StatCard testId="stat-era" label="era" value={analysis.era} span="md:col-span-2" />
      <StatCard testId="stat-production" label="production" value={analysis.production} span="md:col-span-2" />
    </div>
  );
};
